export const decodeDocument = (content: string) => {
  const decodedData = atob(content); // Decode Base64 to binary string
  const bytes = new Uint8Array(decodedData.split('').map((char) => char.charCodeAt(0))); // Convert binary string to typed array
  const decoder = new TextDecoder('utf-8'); // Create a UTF-8 decoder

  return decoder.decode(bytes); // Decode bytes to UTF-8 string
};
